import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import HeaderWithSearch from '../components/HeaderWithSearch'
import HorizontalDashboardMenu from '../components/HorizontalDashboardMenu'
import Time from '../components/Time'
import FullContent from '../components/FullContent'
import CircularProgress from '@material-ui/core/CircularProgress'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  getFleetById
} from '../utils/trackable'
import {
  getProduct
} from '../utils/helper'
class Full extends React.Component {
  constructor (props) {
    super(props)
    this._isMounted = false
    this.state = {
      loading: true,
      keySearch: null
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var product = this.props.match.params.product_id
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(async function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token')).then(function () {
              var newToken = localStorage.getItem('token')
              getUserInfo(newToken)
                .then(response => response.json())
                .then(async function (data) {
                  var products = data.data.attributes.products.fuel_sensor
                  if (getProduct(products, product).length > 0) {
                    var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
                    var fleet = await getFleetById(fleetId)
                    if (fleet) {
                      localStorage.setItem('endpoint', product)
                      let trackables = fleet.trackables
                      let fleetName = fleet.name
                      localStorage.setItem('fleetName', fleetName)
                      self.setState({
                        loading: false,
                        trackables: trackables
                      })
                    } else document.location.href = '/#/error'
                  } else document.location.href = '/#/error'
                })
                .catch((error) => {
                  console.log('error: ', error)
                })
            })
          } else {
            var products = data.data.attributes.products.fuel_sensor
            if (getProduct(products, product).length > 0) {
              var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
              var fleet = await getFleetById(fleetId)
              if (fleet) {
                localStorage.setItem('endpoint', product)
                let trackables = fleet.trackables
                let fleetName = fleet.name
                localStorage.setItem('fleetName', fleetName)
                self.setState({
                  loading: false,
                  trackables: trackables
                })
              } else document.location.href = '/#/error'
            } else document.location.href = '/#/error'
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  render () {
    let headerTitle = "Aujourd'hui flotte " + localStorage.getItem('fleetName')
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu
                  enabled='today'
                />
              </td>
              <td style={styles.content}>
                <HeaderWithSearch
                  title={headerTitle}
                  getKeySearch={(key) => this.setState({ keySearch: key })}
                />
                <HorizontalDashboardMenu
                  enabled='full'
                />
                {this.state.loading ? <CircularProgress
                  style={styles.progressStyle}
                  color='inherit'
                /> : <FullContent
                  keySearch={this.state.keySearch}
                  trackables={this.state.trackables}
                />
                }
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  contentAllList: {
    marginLeft: '14px'
  },
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  progressStyle: {
    marginTop: '60px',
    color: '#7ED321'
  }
}

export default Full
